import React, { useState, useEffect } from "react";
import {
  Grid,
  Input,
  MenuItem,
  Select,
  InputLabel,
  Typography,
} from "@mui/material";
import Box from "@mui/material/Box";
import FormLabel from "@mui/material/FormLabel";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Switch from "@mui/material/Switch";
import Divider from "@mui/material/Divider";
import FormControlLabel from "@mui/material/FormControlLabel";
import { styled } from '@mui/material/styles';
import MuiGrid from '@mui/material/Grid';
import LocalAirportIcon from "@mui/icons-material/LocalAirport";
import { yellow } from '@mui/material/colors';
import Avatar from '@mui/material/Avatar';
import FormControl from '@mui/material/FormControl';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';
import CommentIcon from '@mui/icons-material/Comment';
import * as dayjs from "dayjs";
import Paper from "@mui/material/Paper";

const CenterSelection = ({
  setSelectedCenter,
  selectedCenterValue,
  listCenters,
  hideTitle,
  isFormInvalid,
  setExtras,
  setWeeks,
  edit_mode,
  setAgeGroup
}) => {

  const handleCenterChange = (e) => {
    let center = listCenters.filter((c) => c.id == e)[0];
    setSelectedCenter(center);
    setExtras([]);
    setWeeks([]);
    setAgeGroup(null);
  };

  return (
    <Paper elevation={3} display="flex" className={edit_mode ? '' : 'step-container'}>
      {!hideTitle ?

        <Box sx={{ color: 'primary.main' }}>
          <Typography fontSize={20} fontWeight={'bold'} marginBottom={2} marginTop={2} align="left">
            Choose your centre
          </Typography>
        </Box> : <></>}

      <Grid container>
        <Grid item xs={12}>
          <Select
            value={selectedCenterValue ? selectedCenterValue.id : 0}
            onChange={(e) => handleCenterChange(e.target.value)}
            size="small"
            style={{ width: '100%', textAlign: 'center' }}
            error={isFormInvalid && !selectedCenterValue} >

              {listCenters != null &&
                listCenters
                  .filter(c => c.active === true)
                  .sort((a, b) => a.name.localeCompare(b.name)) 
                  .map((center) => (
                    <MenuItem key={center.id} value={center.id}>
                      {center.name}
                    </MenuItem>
                  ))}

          </Select>
        </Grid>
      </Grid>
    </Paper>
  )
}

export default CenterSelection